import React from "react";
import ApiCommunityDirectoryPage from "./ApiCommunityDirectoryPage";

export default function Ethiopian() {
  return (
    <ApiCommunityDirectoryPage
      community="Ethiopian"
      variant="showcase"
      claimText="Want your business featured in the Ethiopian community guide?"
    />
  );
}